(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // --- MOBİL MENÜ ---
  const menuToggle = qsa('[data-menu-toggle]');
  const drawer = qs('[data-mobile-drawer]');
  menuToggle.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!drawer) return;
      const isHidden = drawer.hidden;
      drawer.hidden = !isHidden;
      document.body.style.overflow = isHidden ? 'hidden' : '';
    });
  });

  // --- SEPET SAYACI ---
  const updateCount = (count) => {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.add('animate-pulse');
      setTimeout(() => el.classList.remove('animate-pulse'), 1000);
    });
  };

  // --- ÜRÜN FORMU (SEPETE EKLE / HEMEN AL) ---
  const productForm = qs('#product-form');
  if (productForm) {
    const variantInput = qs('[data-variant-id]', productForm);
    const jsonEl = qs('[data-product-json]');
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const addBtn = qs('[data-add-to-cart]', productForm);
    const buyBtn = qs('[data-buy-now]', productForm);
    const addBtnDefaultText = addBtn ? addBtn.textContent : '';

    const syncVariant = () => {
      if (!variants.length || !variantInput) return;
      const selected = qsa('input[type="radio"]:checked', productForm).map(i => i.value);
      const match = variants.find(v => selected.every((opt, i) => v[`option${i + 1}`] === opt));
      if (!match) return;

      variantInput.value = match.id;
      [addBtn, buyBtn].forEach((btn) => {
        if (!btn) return;
        btn.disabled = !match.available;
      });
      if (addBtn) addBtn.textContent = match.available ? addBtnDefaultText : 'Tükendi';
    };

    productForm.addEventListener('change', syncVariant);

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = e.submitter;
      const isBuyNow = btn && btn.name === 'checkout';
      const data = new FormData(productForm);
      data.delete('checkout');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        });

        if (!res.ok) throw new Error();

        if (isBuyNow) {
          window.location.href = '/checkout';
        } else {
          const cart = await fetch('/cart.js').then(r => r.json());
          updateCount(cart.item_count);
          if (addBtn) {
            addBtn.textContent = 'Eklendi!';
            setTimeout(() => { addBtn.textContent = addBtnDefaultText; }, 2000);
          }
        }
      } catch (err) {
        productForm.submit();
      }
    });
  }

  // --- ÜRÜN GALERİSİ (geçişli) ---
  qsa('[data-product-gallery]').forEach((gallery) => {
    const slides = qsa('[data-gallery-slide]', gallery);
    const thumbs = qsa('[data-gallery-thumb]', gallery);
    if (slides.length < 2) return;

    let current = 0;

    const goTo = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === current));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index)));
    });

    const prevBtn = qs('[data-gallery-prev]', gallery);
    const nextBtn = qs('[data-gallery-next]', gallery);
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // --- DOKUNMATİK KAYDIRMA (mobil galeri) ---
    const stage = gallery.querySelector('.product-gallery__stage');
    let touchStartX = 0;
    let touchEndX = 0;
    stage.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].screenX; }, { passive: true });
    stage.addEventListener('touchend', (event) => { touchEndX = event.changedTouches[0].screenX; const distance = touchEndX - touchStartX; if (Math.abs(distance) < 50) return; if (distance < 0) { goTo(current + 1); } else { goTo(current - 1); } }, { passive: true });
  });

  // --- STICKY HEADER ---
  const header = qs('[data-header]');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 20 ? '0 10px 40px rgba(0,0,0,.6)' : 'none';
      header.style.background = window.scrollY > 20 ? 'rgba(0,0,0,.95)' : 'rgba(0,0,0,.72)';
    }, { passive: true });
  }

  // --- SSS AKORDİYON ---
  qsa('.faq-item summary').forEach(sum => {
    sum.addEventListener('click', (e) => {
      qsa('.faq-item').forEach(item => {
        if (item !== sum.parentElement) item.removeAttribute('open');
      });
    });
  });


  /* =========================================================================
     ÜRÜN KATALOĞU — ARAMA / FİLTRE / SIRALAMA (TÜM KOLEKSİYON)

     Eski sürüm yalnızca DOM'daki kartları, yani o anki SAYFADAKİ ürünleri
     filtreliyordu; 2. sayfadaki ürünler hiç görünmüyordu.

     Yeni davranış:
       1) Koleksiyon tek sayfaya sığıyorsa  → ağa hiç çıkılmaz, mevcut
          kartlar DOM üzerinden filtrelenir (eski davranışın aynısı).
       2) Koleksiyon birden fazla sayfadaysa → koleksiyonun TÜM ürünleri
          /collections/<handle>/products.json üzerinden 250'lik dilimlerle
          bir kez çekilir, bellekte önbelleğe alınır; arama, kategori/marka
          filtreleri ve sıralama bu tam liste üzerinde çalışır.

     Ağ isteği sadece gerektiğinde (birden fazla sayfa varsa) ve ilk
     filtre/arama/sıralama etkileşiminde yapılır; sonrası anlıktır.
     Filtrelerin hiçbiri aktif değilken sunucudan gelen görünüm (ilk sayfa
     + sayfalama) aynen geri gelir.
     ========================================================================= */

  const CATALOG_CHUNK = 250;   // JSON ucunun tek istekte verebildiği üst sınır
  const CATALOG_MAX_CHUNKS = 20; // güvenlik sınırı (20 x 250 = 5000 ürün)

  const escapeHtml = (value) => {
    const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => map[char]);
  };

  // Türkçe karakterleri ve büyük/küçük harf farkını aramada etkisizleştirir.
  const normalizeText = (value) => String(value == null ? '' : value)
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  /* Para biriminin ondalık basamak sayısı (mağazadan örnekle belirlenir;
     varsayılan 2). Para biçimi çözümlenirken güncellenir. */
  let MONEY_DECIMALS = 2;

  /* Fiyat biçimi: Liquid'den gelen örneklerden mağazanın para formatı
     birebir yeniden üretilir.

       sample: {{ 123456789 | money }}  -> binlik/ondalık ayraçlar + şablon
       unit:   {{ 100 | money }}        -> ondalık basamak sayısı
               ("1,00" = 2 basamak, "1" = 0 basamak, "0,100" = 3 basamak)

     Böylece fiyatlar JPY gibi ondalıksız para birimlerinde 100'e bölünmez
     ve mağaza para birimi/formatı değişse de görünüm bozulmaz. */
  const formatMoney = (() => {
    const fallback = (minor) => {
      const value = (Number(minor) || 0) / 100;
      return `${value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`;
    };

    const node = qs('script[data-catalog-money]');
    if (!node) return fallback;

    let info = null;
    try { info = JSON.parse(node.textContent); } catch (error) { return fallback; }
    if (!info || !info.sample) return fallback;

    // RegExp kurucularında kullanılacak ayraç sınıfı (JS metni olarak)
    const SEPARATORS = "[.,'’\\s\\u00A0\\u202F\\u2009]";

    // 1) Ondalık basamak sayısı: 1 birimin gösteriminden okunur.
    let decimals = 2;
    const unitText = String(info.unit == null ? '' : info.unit).trim();
    if (unitText) {
      const unitNumeric = unitText.replace(/[^\d.,'’\s  ]/g, '').trim();
      const unitTail = unitNumeric.match(new RegExp(`${SEPARATORS}(\\d+)$`));
      decimals = unitTail ? Math.min(unitTail[1].length, 4) : 0;
    }
    const divisor = 10 ** decimals;
    MONEY_DECIMALS = decimals;

    // 2) Binlik ayraç, ondalık ayraç ve şablon: büyük örnekten okunur.
    const sample = String(info.sample).trim();
    const numberMatch = sample.match(/\d[\d.,'’\s  ]*\d/) || sample.match(/\d/);
    if (!numberMatch) return fallback;

    const number = numberMatch[0];
    let integerPart = number;
    let decimalSeparator = decimals > 0 ? ',' : '';
    if (decimals > 0) {
      const fraction = number.match(new RegExp(`${SEPARATORS}(\\d{${decimals}})$`));
      if (fraction) {
        decimalSeparator = fraction[0].slice(0, fraction[0].length - decimals);
        integerPart = number.slice(0, number.length - fraction[0].length);
      }
    }
    const thousandsSeparator = (integerPart.match(/[^\d]/) || [''])[0];
    const template = sample.replace(number, '\u0000');

    return (minor) => {
      const value = Math.abs(Number(minor) || 0) / divisor;
      const parts = value.toFixed(decimals).split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
      const body = parts[1] ? `${whole}${decimalSeparator}${parts[1]}` : whole;
      return template.split('\u0000').join(body);
    };
  })();

  /* Shopify, fiyatları metin olarak döndürür ("140.00" / JPY için "140").
     Kayan nokta hatası olmasın diye küçük para birimine (kuruş) çeviriyoruz. */
  const toMinorUnits = (value) => {
    if (value == null || value === '') return 0;
    const numeric = Number(String(value).trim().replace(',', '.'));
    if (!Number.isFinite(numeric)) return 0;
    return Math.round(numeric * (10 ** MONEY_DECIMALS));
  };

  const sizedImage = (source, width) => {
    if (!source) return '';
    return `${source}${source.includes('?') ? '&' : '?'}width=${width}`;
  };

  /* products.json kaydını katalog ürününe dönüştürür.

     ÖNEMLİ: Storefront /products.json yanıtında ürün düzeyinde fiyat ve stok
     alanı YOKTUR (yanıt anahtarları: id, title, handle, vendor, product_type,
     tags, images, variants, created_at…). Fiyat ve stok yalnızca
     variants[] içinde gelir; bu yüzden burada varyantlardan hesaplanır.
     (Eskiden product.price okunuyordu; tanımsız olduğu için tüm fiyatlar
     "0,00 TL" görünüyordu.) */
  const toCatalogProduct = (product, order) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];

    const variantInfo = variants
      .map((variant) => ({
        id: variant.id,
        available: Boolean(variant.available),
        price: toMinorUnits(variant.price),
        compareAt: toMinorUnits(variant.compare_at_price),
        title: variant.title || ''
      }))
      .filter((variant) => variant.price > 0);

    // Birlikte çalışan bazı uygulamalar ürün düzeyinde de fiyat döndürebilir.
    const productLevelPrice = toMinorUnits(product.price);
    const productLevelCompare = toMinorUnits(
      product.compare_at_price != null ? product.compare_at_price : product.compare_at_price_min
    );

    const allPrices = variantInfo.map((variant) => variant.price);
    if (productLevelPrice > 0) allPrices.push(productLevelPrice);

    const price = allPrices.length ? Math.min(...allPrices) : 0;
    const priceMax = allPrices.length ? Math.max(...allPrices) : 0;
    const cheapestVariant = variantInfo.find((variant) => variant.price === price) || null;
    const compareAt = Math.max(
      productLevelCompare,
      cheapestVariant ? cheapestVariant.compareAt : 0
    );

    const available = typeof product.available === 'boolean'
      ? product.available
      : variants.some((variant) => variant.available);
    const availableVariant = variantInfo.find((variant) => variant.available)
      || variantInfo[0]
      || variants[0]
      || null;

    const tags = Array.isArray(product.tags) ? product.tags : [];
    const firstImage = Array.isArray(product.images) && product.images[0]
      ? (product.images[0].src || product.images[0])
      : '';
    const rawImage = product.featured_image || product.image || firstImage || '';
    const image = typeof rawImage === 'string' ? rawImage : (rawImage && rawImage.src) || '';

    const title = product.title || '';
    const vendor = product.vendor || '';
    const type = product.product_type || '';
    const handle = product.handle || '';

    return {
      id: product.id,
      title,
      vendor,
      type,
      url: `/products/${handle}`,
      image: sizedImage(image, 600),
      image2x: sizedImage(image, 900),
      available: Boolean(available),
      variantId: availableVariant ? availableVariant.id : null,
      price,
      priceMax,
      priceVaries: priceMax > price,
      compareAt,
      createdAt: Date.parse(product.created_at || product.published_at || '') || 0,
      order: order || 0,
      tags: tags.map((tag) => normalizeText(tag)),
      vendorNormalized: normalizeText(vendor),
      titleNormalized: normalizeText(title),
      // Kategori çipleri ürün tipi + etiket + handle + başlık içinde aranır
      categoryText: normalizeText([type, ...tags, handle, title].join(' ')),
      searchText: normalizeText([title, vendor, type, ...tags, handle].join(' '))
    };
  };

  // Katalog kartının HTML'i (product-card sınıfları tema CSS'i ile uyumlu)
  const renderCard = (product) => {
    const typeLine = product.type || product.vendor;
    const compare = product.compareAt > product.price
      ? `<s class="price price--compare">${escapeHtml(formatMoney(product.compareAt))}</s>`
      : '';
    // Varyant fiyatları farklıysa "Başlangıç:" ile en düşük fiyat gösterilir.
    const priceLabel = product.priceVaries
      ? `Başlangıç: ${formatMoney(product.price)}`
      : formatMoney(product.price);

    const action = product.available && product.variantId
      ? `<form method="post" action="/cart/add" class="catalog-quick-buy-form">
           <input type="hidden" name="id" value="${escapeHtml(product.variantId)}">
           <input type="hidden" name="quantity" value="1">
           <button type="submit" name="checkout" class="catalog-quick-buy">Hemen Al</button>
         </form>`
      : `<button type="button" class="catalog-quick-buy" disabled aria-disabled="true">Tükendi</button>`;

    return `<div class="catalog-product" data-catalog-product data-product-id="${escapeHtml(product.id)}">
        <a class="product-card" href="${escapeHtml(product.url)}">
          <span class="product-card__media">
            ${product.image
              ? `<img src="${escapeHtml(product.image)}"${product.image2x ? ` srcset="${escapeHtml(product.image)} 600w, ${escapeHtml(product.image2x)} 900w" sizes="(max-width: 640px) 100vw, 25vw"` : ''} alt="${escapeHtml(product.title)}" loading="lazy" decoding="async" width="600" height="450">`
              : ''}
          </span>
          <span class="product-card__info">
            ${typeLine ? `<span class="product-card__type">${escapeHtml(typeLine)}</span>` : '<span class="product-card__type"></span>'}
            <span class="product-card__title">${escapeHtml(product.title)}</span>
            <span class="product-card__meta">
              <span class="price">${escapeHtml(priceLabel)}</span>
              ${compare}
            </span>
          </span>
        </a>
        ${action}
      </div>`;
  };

  qsa('[data-catalog]').forEach((catalog) => {
    const grid = qs('[data-catalog-grid]', catalog);
    if (!grid) return;

    const searchInput = qs('[data-catalog-search]', catalog);
    const sortSelect = qs('[data-catalog-sort]', catalog);
    const countEl = qs('[data-catalog-count]', catalog);
    const emptyEl = qs('[data-catalog-empty]', catalog);
    const paginationEl = qs('[data-catalog-pagination]', catalog);
    const loadingEl = qs('[data-catalog-loading]', catalog);
    const moreWrap = qs('[data-catalog-more]', catalog);
    const moreBtn = qs('[data-catalog-more-button]', catalog);

    const indexUrl = catalog.dataset.catalogIndexUrl || '';
    const pageSize = Math.max(4, Number(catalog.dataset.catalogPageSize) || 24);
    const serverTotal = Number(catalog.dataset.catalogTotal) || 0;

    // Filtre sonuçları eksik görünmesin: küçük/orta koleksiyon tek seferde
    // gösterilir, çok büyük koleksiyonlarda 240'lık parçalarla büyütülür.
    const renderStep = Math.max(240, pageSize);
    let renderLimit = renderStep;

    // Sunucudan gelen ilk sayfa (yedeğe alıyoruz ki filtreler sıfırlanınca geri dönebilsin)
    const serverNodes = qsa('[data-catalog-product]', grid);
    const serverMarkup = grid.innerHTML;
    const serverCountText = countEl ? countEl.textContent.trim() : '';
    const serverHasPagination = Boolean(paginationEl && !paginationEl.hidden);
    // Koleksiyonun tamamı zaten DOM'da mı? (tek sayfalık koleksiyon)
    const fullCollectionInDom = serverTotal
      ? serverTotal <= serverNodes.length
      : !serverHasPagination;

    const state = { category: 'all', brand: 'all', search: '', sort: 'featured' };

    /* URL'den gelen değer ("dekor") ile çipin değeri
       ("dekor dekorasyon decoration") kelime bazında eşleştirilir. */
    const chipMatchesState = (chipValue, stateValue) => {
      const chipText = normalizeText(chipValue);
      const valueText = normalizeText(stateValue);
      if (chipText === valueText) return true;
      const chipTerms = chipText.split(' ').filter(Boolean);
      const valueTerms = valueText.split(' ').filter(Boolean);
      return chipTerms.some((term) => valueTerms.includes(term));
    };
    let indexProducts = null;   // koleksiyonun tamamı
    let indexPromise = null;
    let indexFailed = false;
    let applyPending = false;

    const groups = qsa('[data-filter-group]', catalog);

    /* Kategori eşleşmesi TAM KELİME ile yapılır: "ev" terimi "dev", "devre"
       gibi kelimelerin içinde eşleşmez. Kategori metni kelimelere bölünür,
       filtre terimi bu kelime kümesinde aranır. */
    const includesAnyTerm = (haystack, filterValue) => {
      if (!filterValue || filterValue === 'all') return true;
      const tokens = new Set(normalizeText(haystack).split(/[^a-z0-9]+/).filter(Boolean));
      return normalizeText(filterValue).split(/\s+/).some((term) => term && tokens.has(term));
    };

    const matchesBrand = (product) => {
      if (state.brand === 'all') return true;
      const brand = normalizeText(state.brand);
      return product.tags.includes(brand)
        || product.vendorNormalized === brand
        || (product.vendorNormalized && product.vendorNormalized.includes(brand));
    };

    const compareProducts = (a, b) => {
      switch (state.sort) {
        case 'title-ascending':
          return a.titleNormalized.localeCompare(b.titleNormalized, 'tr');
        case 'title-descending':
          return b.titleNormalized.localeCompare(a.titleNormalized, 'tr');
        case 'price-ascending':
          return a.price - b.price;
        case 'price-descending':
          return b.price - a.price;
        case 'date-ascending':
          return a.createdAt - b.createdAt;
        case 'date-descending':
          return b.createdAt - a.createdAt;
        default:
          return a.order - b.order;
      }
    };

    const isDefaultView = () => state.sort === 'featured'
      && state.category === 'all'
      && state.brand === 'all'
      && !state.search;

    const setLoading = (isLoading) => {
      if (loadingEl) loadingEl.hidden = !isLoading;
    };

    const setMoreVisible = (visible) => {
      if (moreWrap) moreWrap.hidden = !visible;
    };

    // Koleksiyonun tamamını (250'lik dilimler hâlinde) bir kez çeker.
    const loadIndex = () => {
      if (!indexUrl || indexPromise) return indexPromise;

      setLoading(true);

      indexPromise = (async () => {
        const collected = [];

        for (let page = 1; page <= CATALOG_MAX_CHUNKS; page += 1) {
          const url = `${indexUrl}?limit=${CATALOG_CHUNK}&page=${page}`;
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const data = await response.json();
          const batch = Array.isArray(data.products) ? data.products : [];
          batch.forEach((product) => collected.push(toCatalogProduct(product, collected.length)));

          if (batch.length < CATALOG_CHUNK) break;
        }

        if (!collected.length) throw new Error('Boş ürün listesi');
        return collected;
      })();

      indexPromise
        .then((items) => {
          indexProducts = items;
          indexFailed = false;
          if (serverTotal && items.length < serverTotal) {
            console.warn(`[katalog] ${serverTotal} ürünün ${items.length} tanesi alınabildi.`);
          }
        })
        .catch((error) => {
          indexProducts = null;
          indexFailed = true;
          console.warn('[katalog] Tüm ürün listesi alınamadı, sayfadaki ürünlerle devam ediliyor:', error);
        })
        .finally(() => {
          setLoading(false);
          indexPromise = null;
        });

      return indexPromise;
    };

    /* 1) Hiç filtre/arama/sıralama yok → sunucudan gelen görünüm */
    const restoreServerView = () => {
      if (grid.dataset.clientRendered === 'true') {
        grid.innerHTML = serverMarkup;
        grid.dataset.clientRendered = 'false';
      } else {
        // DOM modunda kullanıcı sıralama yapmış olabilir; sunucu sırasına dön.
        qsa('[data-catalog-product]', grid)
          .sort((a, b) => Number(a.dataset.originalOrder || 0) - Number(b.dataset.originalOrder || 0))
          .forEach((card) => grid.appendChild(card));
      }

      if (paginationEl) paginationEl.hidden = false;
      if (emptyEl) emptyEl.hidden = true;
      if (countEl && serverCountText) countEl.textContent = serverCountText;

      setMoreVisible(false);
    };

    /* 2) Koleksiyon tek sayfa → kartları DOM üzerinden filtrele */
    const applyToRenderedCards = () => {
      if (grid.dataset.clientRendered === 'true') {
        grid.innerHTML = serverMarkup;
        grid.dataset.clientRendered = 'false';
      }

      const cards = qsa('[data-catalog-product]', grid);
      let visibleCount = 0;

      cards.forEach((card, index) => {
        card.dataset.originalOrder = card.dataset.originalOrder || String(index);

        const matchesSearch = !state.search
          || normalizeText(card.dataset.search).includes(normalizeText(state.search));
        const matchesCategory = includesAnyTerm(normalizeText(card.dataset.category), state.category);
        const matchesBrandFilter = state.brand === 'all'
          || normalizeText(card.dataset.tags || '')
            .split('|')
            .map((tag) => normalizeText(tag))
            .includes(normalizeText(state.brand));

        const visible = matchesSearch && matchesCategory && matchesBrandFilter;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (state.sort !== 'featured') {
        const ordered = cards.slice().sort((a, b) => compareProducts({
          titleNormalized: normalizeText(a.dataset.title),
          price: Number(a.dataset.price),
          createdAt: Number(a.dataset.created),
          order: Number(a.dataset.originalOrder)
        }, {
          titleNormalized: normalizeText(b.dataset.title),
          price: Number(b.dataset.price),
          createdAt: Number(b.dataset.created),
          order: Number(b.dataset.originalOrder)
        }));
        ordered.forEach((card) => grid.appendChild(card));
      } else {
        // "Öne çıkan": koleksiyonun kendi sırası
        cards.slice()
          .sort((a, b) => Number(a.dataset.originalOrder || 0) - Number(b.dataset.originalOrder || 0))
          .forEach((card) => grid.appendChild(card));
      }

      if (countEl) {
        countEl.textContent = visibleCount === cards.length
          ? `${visibleCount} ürün`
          : `${visibleCount} / ${cards.length} ürün`;
      }

      if (emptyEl) emptyEl.hidden = visibleCount !== 0;
      if (paginationEl) paginationEl.hidden = true;
      setMoreVisible(false);
    };

    /* 3) Tüm koleksiyon çekildi → bu tam liste üzerinden filtrele + sırala */
    const applyToFullCollection = () => {
      const filtered = indexProducts.filter((product) => {
        if (state.search && !product.searchText.includes(normalizeText(state.search))) return false;
        if (!includesAnyTerm(product.categoryText, state.category)) return false;
        if (!matchesBrand(product)) return false;
        return true;
      });

      const ordered = state.sort === 'featured'
        ? filtered
        : filtered.slice().sort(compareProducts);

      const shown = ordered.slice(0, renderLimit);
      grid.innerHTML = shown.map(renderCard).join('');
      grid.dataset.clientRendered = 'true';

      if (countEl) {
        countEl.textContent = ordered.length === indexProducts.length
          ? `${ordered.length} ürün`
          : `${ordered.length} / ${indexProducts.length} ürün`;
      }

      if (emptyEl) emptyEl.hidden = ordered.length !== 0;
      if (paginationEl) paginationEl.hidden = true;
      setMoreVisible(ordered.length > shown.length);

      if (moreBtn) {
        moreBtn.textContent = `Daha fazla göster (${ordered.length - shown.length})`;
      }
    };

    const applyCatalog = () => {
      if (isDefaultView()) {
        restoreServerView();
        return;
      }

      if (fullCollectionInDom) {
        applyToRenderedCards();
        return;
      }

      if (!indexProducts) {
        if (indexFailed) {
          // JSON ucu kapalı/erişilemezse eldeki kartlarla devam et.
          applyToRenderedCards();
          return;
        }

        setLoading(true);

        if (!applyPending) {
          applyPending = true;
          loadIndex().finally(() => {
            applyPending = false;
            applyCatalog();
          });
        }
        return;
      }

      applyToFullCollection();
    };

    // Filtre çiplerine tıklama
    groups.forEach((group) => {
      group.addEventListener('click', (event) => {
        const button = event.target.closest('[data-filter-value]');
        if (!button || !group.contains(button)) return;

        const filterName = group.dataset.filterGroup;
        state[filterName] = button.dataset.filterValue;
        renderLimit = renderStep;

        qsa('[data-filter-value]', group).forEach((chip) => {
          const active = chip === button;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', String(active));
        });

        syncUrl();
        applyCatalog();
      });
    });

    // Anlık arama
    if (searchInput) {
      let searchTimer;
      searchInput.addEventListener('input', () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => {
          state.search = searchInput.value;
          renderLimit = renderStep;
          syncUrl();
          applyCatalog();
        }, 120);
      });
    }

    // Sıralama
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        state.sort = sortSelect.value;
        renderLimit = renderStep;
        syncUrl();
        applyCatalog();
      });
    }

    // "Daha fazla göster"
    if (moreBtn) {
      moreBtn.addEventListener('click', () => {
        renderLimit += renderStep;
        applyCatalog();
      });
    }

    /* Filtreleri adres çubuğuna yazar: sayfa yenilenince veya link
       paylaşılınca aynı sonuçlar açılır. (kategori, marka, q, sort_by) */
    function syncUrl() {
      try {
        const params = new URLSearchParams(window.location.search);
        if (state.search) params.set('q', state.search); else params.delete('q');
        if (state.category !== 'all') params.set('kategori', state.category); else params.delete('kategori');
        if (state.brand !== 'all') params.set('marka', state.brand); else params.delete('marka');
        if (state.sort !== 'featured') params.set('sort_by', state.sort); else params.delete('sort_by');

        const query = params.toString();
        window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash || ''}`);
      } catch (error) {
        /* Sandbox/gizli sekme gibi ortamlarda sessizce yok say */
      }
    }

    // Adres çubuğundaki filtreleri geri yükle
    const readUrl = () => {
      let params;
      try { params = new URLSearchParams(window.location.search); } catch (error) { return false; }

      const search = params.get('q');
      const category = params.get('kategori');
      const brand = params.get('marka');
      const sort = params.get('sort_by');

      if (search) state.search = search;
      if (category) state.category = category;
      if (brand) state.brand = brand;
      if (sort && (!sortSelect || Array.from(sortSelect.options).some((option) => option.value === sort))) {
        state.sort = sort;
      }

      if (searchInput && state.search) searchInput.value = state.search;
      if (sortSelect) sortSelect.value = state.sort;

      groups.forEach((group) => {
        const value = state[group.dataset.filterGroup];
        if (value == null) return;
        qsa('[data-filter-value]', group).forEach((chip) => {
          const active = chipMatchesState(chip.dataset.filterValue, value);
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', String(active));
        });
      });

      return !isDefaultView();
    };

    // Önden yükleme: sayfada gezinen kullanıcı için indeksi boşta çeker
    const prefetch = () => {
      if (fullCollectionInDom || indexProducts || indexPromise || indexFailed) return;
      loadIndex().finally(() => {
        // Indeks geldikten sonra ekranda aktif bir filtre varsa güncelle
        if (!applyPending) applyCatalog();
      });
    };

    readUrl();

    if (isDefaultView()) {
      restoreServerView();
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prefetch, { timeout: 3000 });
      } else {
        setTimeout(prefetch, 1200);
      }
    } else {
      applyCatalog();
    }
  });

})();
